export const env = {
  /** Base URL for authenticated API calls (FastAPI UserPortal routes) */
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/v1_0/UserPortal',
  /** Base URL for unauthenticated calls (login, account ops) */
  AUTH_BASE_URL: import.meta.env.VITE_AUTH_BASE_URL || '/v1_0/UserPortal/Auth',
  /** Google Maps API key */
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
} as const;
